<div class="body ui container" fxLayout="column">

	<div fxLayout="row" fxLayoutAlign='space-between center' class="top">

		<div>
			<span>Home</span>
			<h2 class="ui primary header">Create an Account</h2>
		</div>

	</div>
	<div class="ui divider" appMargin marginY="3"></div>

	<div fxLayout="row" fxLayoutGap='30px'>
		<div fxFlex="grow">


			<div class="ui padded board segment no-border" fxLayout="column" appPadding="10">
				<div appMargin marginB="10">Company details you provided</div>

				<div fxFlex fxLayout="row" fxLayoutAlign="space-between start" appMargin marginB="10">
					<div fxFlex>
						<div class="sub-label">COMPANY OWNERSHIP TYPE</div>
						<div class="sub-value">Nigerian Owned</div>
					</div>

					<div fxFlex>
						<div class="sub-label">COMPANY TYPE</div>
						<div class='sub-value'>Private Company Limited by Shares</div>
					</div>

				</div>


				<div fxFlex fxLayout="row" fxLayoutAlign="space-between start">
					<div fxFlex>
						<div class="sub-label">COMAPNY RC/BN NUMBER</div>
						<div class="sub-value">861455</div>
					</div>


					<div fxFlex>
						<div class="sub-label">COMPANY TAX IDENTIFICATION NUMBER (TIN)</div>
						<div class="sub-value">05065899-0001</div>
					</div>

				</div>
			</div>




			<div class="ui tertiary segment no-border" fxLayout="row" fxLayoutAlign="space-between center">
				<div fxFlex="7%">
					<i class="exclamation triangle  big colored primary icon"></i>
				</div>

				<div fxFlex>
					You are allowed a maximum of <strong>3 attempts.</strong> You have <strong>2 out of 3</strong>
					attempts left. If
					you are unable to proceed with your registration, <strong class="text">click here</strong> to send
					us a message.
				</div>

			</div>

			<div class="ui  segment light no-border" fxLayout="row" fxLayoutAlign="space-between center">
				<div fxFlex="7%">
					<i class="exclamation circle big colored primary icon"></i>
				</div>

				<div fxFlex>
					<strong>Oops!</strong> The system was unable to match the company name you provided with
					a record in out database. You may provide your company details agian by
					clicking on the <strong>Provide Details Again </strong> button below or click on the <strong>Report
						Issue</strong> button to report the issue.
				</div>

			</div>


			<div class="ui right floated buttons">
				<button class="ui primary basic button " routerLink="/home-page/sign-in" appMargin
					marginR="10px">Exit</button>
				<button class="ui primary basic button " routerLink="/home-page/sign-in" appMargin marginR="10px">Report
					Issue</button>
				<button class="ui primary basic button " routerLink="/home-page/account/identification">Provide Details
					Again</button>
			</div>

		</div>





            <div fxFlex="30%" appPadding paddingT="0" fxLayout="column"  class="ui vertical basic segment" [ngClass]="{'loading':mpending}">
				<div class="side" appPadding="7">
							<div [innerHtml]="registrationSidebar">

					</div>
				</div>
			</div>

	</div>

</div>